import * as React from "react";
import { ReviewTileItem } from "@/types/tile.types";
import { useTileCopy } from "./useTileCopy";

interface UseBulkCopyProps {
  onComplete?: (result: { success: number; failed: number }) => void;
  onError?: (error: string) => void;
}

export const useBulkCopy = ({ onComplete, onError }: UseBulkCopyProps) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const copyHook = useTileCopy();

  const copyAllTiles = async (
    tiles: ReviewTileItem[],
    format: "standard" | "table" | "json" | "summary" = "standard"
  ) => {
    if (tiles.length === 0) {
      onComplete?.({ success: 0, failed: 0 });
      return;
    }
    setIsProcessing(true);
    try {
      let success = false;
      switch (format) {
        case "table":
          success = await copyHook.copyTilesAsTable(tiles);
          break;
        case "json":
          success = await copyHook.copyTilesAsJSON(tiles);
          break;
        case "summary":
          success = await copyHook.copyTilesSummary(tiles);
          break;
        default:
          success = await copyHook.copyMultipleTiles(tiles);
      }
      onComplete?.({ success: success ? tiles.length : 0, failed: success ? 0 : tiles.length });
    } catch (error: unknown) {
      console.error("Error copying tiles:", error);
      onError?.(error instanceof Error ? error.message : "Unknown error");
      onComplete?.({ success: 0, failed: tiles.length });
    } finally {
      setIsProcessing(false);
    }
  };

  return { isProcessing, copyAllTiles };
};
